import store from '@/stores/store';
import { ModuleContext } from '@/stores/moduleConst';
import LocalForage from 'localforage';

// Implement the driver here.
class IndexedDB {
  _db = null;
  _dbName = 'mimosa';
  _keyField = '_k';
  _valueField = '_v';
  _table = 'cache';

  constructor() {
    const me = this;
    const { Context } = store.state[ModuleContext];
    if (Context) {
      me._table = String(Context.DatabaseId);
      try {
        this._db = LocalForage;
        this._db.config({
          driver: LocalForage.INDEXEDDB,
          name: `${me._dbName}_${me._table}`,
          version: 1.0,
          storeName: 'keyvaluepairs', // Should be alphanumeric, with underscores.
          description: 'Index db for mimosa online'
        });
      } catch (err) {
        //   console.error(err);
      }
    }
  }

  /**
   * Lấy thông tin dữ liệu lưu trong index theo key
   * @param {*} key
   * @param {*} fn
   * @returns
   * HTHIEP 29.04.2022
   */
  async get(key, fn) {
    key = `ms_mimosa_${key}`;
    let data = await this._db.getItem(key, fn);
    try {
      //Thực hiện ép kiểu về date objec do stringtyfy đưa kiểu date về string
      const dateFormat = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
      function reviver(key, value) {
        if (typeof value === 'string' && dateFormat.test(value)) {
          return new Date(value);
        }
        return value;
      }
      data = JSON.parse(data, reviver);
    } catch (error) {}
    return data;
  }

  /**
   * Lưu trữ dữ liệu vào indexdb
   * @param {*} key
   * @param {*} data
   * @param {*} fn
   * HTHIEP 29.04.2022
   */
  async set(key, data, fn) {
    key = `ms_mimosa_${key}`;
    let stringData = '';
    if (typeof data === 'object') {
      stringData = JSON.stringify(data);
    } else {
      stringData = data;
    }
    await this._db.setItem(key, stringData, fn);
  }

  /**
   * Xóa dữ liệu trong indexdb theo key
   * @param {*} key
   * @param {*} fn
   * HTHIEP 29.04.2022
   */
  async delete(key, fn) {
    key = `ms_mimosa_${key}`;
    await this._db.removeItem(key, fn);
  }

  /**
   * Clear toàn bộ dữ liệu trong indexdb
   * HTHIEP 29.04.2022
   */
  async clear() {
    await this._db.clear();
  }

  getTable() {
    return this._table;
  }

  /**
   * Lấy ra toàn bộ keys
   * TVDAT 14/12/2022
   */
  async getKeys() {
    return await this._db.keys();
  }
}

export default IndexedDB;
